import * as React from 'react';
const { useCallback } = React;

import {
	Root,
	ButtonStyled
} from './styled';


export type NavPickerDataSourceItem<T = string | number> = {
	value: T;
	text: string;
};

export type NavPickerProps<T> = {
	dataSource: Array<NavPickerDataSourceItem<T>>;
	value: T;
	onChange: (e: React.SyntheticEvent, value: T, item: NavPickerDataSourceItem<T>) => void;
};

export type NavPickerComponent<T = string | number> = React.SFC<NavPickerProps<T>>;

const NavPicker: NavPickerComponent = (props) => {
	const {
		dataSource,
		value,
		onChange,
		...rest
	} = props;

	const handleClick = useCallback((source: NavPickerDataSourceItem) => (e: React.SyntheticEvent) => {
		e.stopPropagation();
		onChange(e, source.value, source);
	}, []);

	return (
		<Root {...rest}>
			{
				dataSource && dataSource.map((source, idx) => {
					return (
						<ButtonStyled
							key={idx}
							isActive={source.value === value}
							onClick={handleClick(source)}>
							{source.text}
						</ButtonStyled>
					);
				})
			}
		</Root>
	);
};

export default NavPicker;
